var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("setups.title")) + "\n    "),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "ring-card__header-buttons" }, [
          _c(
            "small",
            [
              _c("el-tooltip", { attrs: { content: "Prev page" } }, [
                _c(
                  "a",
                  {
                    staticStyle: { "margin-right": "10px" },
                    on: {
                      click: function ($event) {
                        return _vm.moveBack()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-arrow-left" }),
                    _vm._v(" Prev"),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("small", [_vm._v("|")]),
              _vm._v(" "),
              _c("el-tooltip", { attrs: { content: "Next page" } }, [
                _c(
                  "a",
                  {
                    staticStyle: { "margin-left": "10px" },
                    on: {
                      click: function ($event) {
                        return _vm.moveFwd()
                      },
                    },
                  },
                  [
                    _vm._v(" Next "),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "small",
            [
              _c("RefreshButton", {
                nativeOn: {
                  click: function ($event) {
                    return _vm.nextSetups(1, 10)
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "card-content",
      },
      [
        _c(
          "el-table",
          {
            staticClass: "device-setup-table",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.setups },
          },
          [
            _vm.showDeviceName
              ? _c("el-table-column", {
                  attrs: { label: "Device" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticClass: "device-name" }, [
                              _vm._v(
                                _vm._s(_vm.startCase(scope.row.doorbot_kind)) +
                                  " - " +
                                  _vm._s(scope.row.doorbot_description)
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    354755657
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "status", label: "Setup" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("setup-details", {
                        attrs: {
                          visible: scope.row.visible,
                          details: scope.row,
                        },
                        on: {
                          "update:visible": function ($event) {
                            return _vm.$set(scope.row, "visible", $event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              scope.row.visible = true
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "setup-id" }, [
                            _vm._v(_vm._s("#" + scope.row.id)),
                          ]),
                          _vm._v(" "),
                          _c("time-zone-formatter", {
                            staticClass: "setup-date",
                            attrs: { "current-time": scope.row.updated_at },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Status", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("capitalize")(scope.row.status)) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "client_device_connected",
                label: "Ring AP Connected",
                width: "240",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("font-awesome-icon", {
                        class: {
                          "active-device__icon":
                            scope.row.client_device_connected,
                          "inactive-device__icon":
                            !scope.row.client_device_connected,
                        },
                        attrs: { icon: _vm.circleIcon },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "doorbot_connected",
                label: "Device Connected to Wifi",
                width: "240",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "span",
                        {
                          class: {
                            "active-device__icon": scope.row.doorbot_connected,
                            "inactive-device__icon":
                              !scope.row.doorbot_connected,
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.circleIcon },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }